module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('em', [_vm._v("Main Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s parents, siblings, grandmother and uncle")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ahmed, King of Samarkand, Babur’s uncle")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Esan Dawlat, Babur’s maternal grandmother")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Jahangir, Babur’s half-brother")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Khanzada, Babur’s older sister")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Kutlugh Nigar, Babur’s mother")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Umar-Shaikh, King of Ferghana, Babur’s father")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s wives")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ayisha, daughter of the chief of the Mangligh clan")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Maham, Babur’s favourite wife and mother of Humayun")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Gulrukh, mother of Kamran and Askari")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Bibi Mubarak, daughter of the chief of the Yusufzai clan")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Dildar, mother of Hindal")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s sons")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Humayun")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Kamran")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Askari")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Hindal")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s cousins")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Azar Khan, nobleman of Ferghana")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Mahmud, Prince of Kunduz")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Mirza Khan, chieftain of Ferghana")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Tambal, nobleman of Ferghana")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s inner circle")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Baburi, a former market boy and Babur’s closest friend")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Baisanghar, originally an officer of Samarkand, subsequently Babur’s loyal commander and, even later, father-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Kasim, one of Babur’s political advisers, often used by him as an ambassador")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Wazir Khan, milk-brother to Babur’s father and Babur’s guide and chief mentor in his childhood and early years as king")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Abdul-Malik, a physician")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Ferghana")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Baba Qashqa, comptroller of the royal household")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Baqi Beg, court astrologer")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Fatima, chief waiting woman")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Qambar-Ali, vizier")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Rehana, an old woman whose grandfather rode with Timur to sack Delhi")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Roxanna, concubine of Babur’s father and mother of Jahangir")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Walid Butt, Esan Dawlat’s steward")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Yadgar, Babur’s favourite inhabitant of a Ferghana brothel")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Yusuf, keeper of the treasury")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s tribal leaders")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ali-Dost, a chieftain from western Ferghana")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ali Gosht, Babur’s master-of-horse and later chief quartermaster")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ali Mazid Beg, lord of Shahrukiyyah")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Baba Yasaval, warrior from near Herat")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Hussain Mazid, headman of Sayram and cousin of Ali Mazid Beg")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s chief enemy in Central Asia")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Shaibani Khan, powerful leader of the Uzbek clans and blood enemy of Babur’s people and all those descended from Timur")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Persia")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Shah Ismail of Persia")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Mullah Husayn, Shiite mullah serving Shah Ismail")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Turkey")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Ali-Quli, master-gunner")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Kabul")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Bahlul Ayyub, grand vizier")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Haydar Taqi, keeper of the Royal Seal")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Muhammad-Muquim Arghun, chief of the Hazaras")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Wali Gul, guardian of the Royal Treasuries")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Hindustan")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Buwa, mother of Sultan Ibrahim Lodi")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Firoz Khan, Hindustani warlord")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Gwalior royal family, owners of the Koh-i-Nur diamond, the ‘Mountain of Light’")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Rana Sanga, Hindu ruler of the Rajput state of Mewar")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Sultan Ibrahim Lodi, ruler of the great Delhi Sultanate and overlord of Hindustan")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Roshanna, Buwa’s serving woman")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_c('em', [_c('strong', [_vm._v("Babur’s ancestors")])])]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Genghis Khan")]), _vm._v(" "), _c('p', {
    staticClass: "hangindent-para"
  }, [_vm._v("Timur, known in the West as Tamburlaine from a corruption of ‘Timur-i-Lang’, ‘Timur the Lame’")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf76d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 69
// module chunks = 0